import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCodeBox12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconCodeBox12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1.5 2h9a.5.5 0 0 1 .5.5v7.286a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V2.5a.5.5 0 0 1 .5-.5M0 2.5A1.5 1.5 0 0 1 1.5 1h9A1.5 1.5 0 0 1 12 2.5v7.286a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5zm4.277 2.234a.5.5 0 1 0-.707-.708L1.938 5.658l-.354.354.354.353L3.57 7.997a.5.5 0 1 0 .707-.707L2.998 6.012zm3.446 0a.5.5 0 1 1 .708-.708l1.631 1.632.354.354-.354.353-1.631 1.632a.5.5 0 1 1-.708-.707l1.279-1.278zm-.902-.755a.5.5 0 0 1 .288.646l-1.213 3.16a.5.5 0 1 1-.933-.358l1.212-3.16a.5.5 0 0 1 .646-.288"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCodeBox12);
